import { render, staticRenderFns } from "./Model12.vue?vue&type=template&id=8505a0d4&scoped=true"
import script from "./Model12.vue?vue&type=script&lang=js"
export * from "./Model12.vue?vue&type=script&lang=js"
import style0 from "./Model12.vue?vue&type=style&index=0&id=8505a0d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8505a0d4",
  null
  
)

export default component.exports